/**
 * @generated SignedSource<<a26780337adfcc15ec26908f79550ee6>>
 * @relayHash bcef1344cba25537e7a53d600a9db480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 88265765b0265d05b90e13c21862d0aa44f2965a1a92f528efc0bc2ff1c0744d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcCustomerServiceServiceHubsPageQuery } from './srcCustomerServiceServiceHubsPageQuery.graphql';

const node: PreloadableConcreteRequest<srcCustomerServiceServiceHubsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "88265765b0265d05b90e13c21862d0aa44f2965a1a92f528efc0bc2ff1c0744d",
    "metadata": {},
    "name": "srcCustomerServiceServiceHubsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
